export default {
  default: () => import("/vercel/path0/layouts/default.vue"),
  "logged-in": () => import("/vercel/path0/layouts/loggedIn.vue")
}